import { render, staticRenderFns } from "./EventVisual.vue?vue&type=template&id=e24ff368"
import script from "./EventVisual.vue?vue&type=script&lang=js"
export * from "./EventVisual.vue?vue&type=script&lang=js"
import style0 from "./EventVisual.vue?vue&type=style&index=0&id=e24ff368&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports